<div *ngIf="status === 'true'">
  <i class="material-icons column-icon">gavel</i> <span>{{'IS_STAFF' | translate}}</span>
</div>
<div *ngIf="status === 'false'">
  <span>{{'IS_NOT_STAFF' | translate}}</span>
</div>

